import { deserializationPolicy as createDeserializationPolicy, exponentialRetryPolicy as createExponentialRetryPolicy, redirectPolicy as createRedirectPolicy, systemErrorRetryPolicy as createSystemErrorRetryPolicy } from '@azure/ms-rest-js';
import { Api } from '@ori/global-api-client';
import { createAcceptLanguagePolicy, createAuthorizationPolicy, createTenantPolicy, hash } from "../internals";
const clients = new Map();
export function createGlobalApiClient(options) {
  const key = hash(JSON.stringify(options));
  if (clients.has(key)) {
    return clients.get(key);
  }
  const {
    acceptLanguage,
    baseUrl,
    tenant,
    token
  } = options;
  const client = new Api({
    baseUri: baseUrl,
    requestPolicyFactories: [createAcceptLanguagePolicy(acceptLanguage), createAuthorizationPolicy(token), createDeserializationPolicy(), createExponentialRetryPolicy(), createRedirectPolicy(), createSystemErrorRetryPolicy(), createTenantPolicy(tenant)]
  });
  clients.set(key, client);
  return client;
}
//# sourceMappingURL=createGlobalApiClient.js.map